import { useMemo } from "react";

export const DATA_SAVE_URL = "https://matlablk.com";
// export const DATA_SAVE_URL = "http://localhost:8080";
// toLocaleString("en-US", {
//     style: "currency",
//     currency: "LKR",
//   })

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const xLabels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatNumberWithCommas = (number) => {
  // Handle null/undefined
  if (number == null) return "0.00";

  const isNegative = number < 0;
  const absoluteNumber = Math.abs(number);
  const [integerPart, decimalPart = "00"] = absoluteNumber
    .toString()
    .split(".");
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formattedDecimal = decimalPart.padEnd(2, "0").slice(0, 2);
  const formattedNumber = `${formattedInteger}.${formattedDecimal}`;

  return isNegative ? `(${formattedNumber})` : formattedNumber;
};
